import { render, staticRenderFns } from "./WPMediaInput.vue?vue&type=template&id=5551cf2a&"
import script from "./WPMediaInput.vue?vue&type=script&lang=ts&"
export * from "./WPMediaInput.vue?vue&type=script&lang=ts&"
import style0 from "./WPMediaInput.vue?vue&type=style&index=0&id=5551cf2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports